export default "__VITE_ASSET__BmAR9NMN__";